import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid2';
import {
  GridButton,
  GridIconFab,
  Placeholder,
  GridNumberField,
} from '../../Form/shared';
import { positiveInteger } from '../../Form/validators';
import DelayCodesDialog from './DelayCodesDialog';
import { FormBlock, FormTextField } from '../../Form';
import withDeletePopup from '../../withDeletePopup';

const initialValue = {
  code: null,
  duration: null,
};

class Delays extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDelayCodesDialogOpen: false,
      currentItemIndex: null,
    };
  }

  handleAddClick = () => {
    const { setFieldValue, values } = this.props;
    setFieldValue(
      `outbound.delays[${values.outbound.delays.length}]`,
      initialValue
    );
  };

  handleDeleteClick = index => {
    const { setFieldValue, values } = this.props;
    setFieldValue('outbound.delays', [
      ...values.outbound.delays.slice(0, index),
      ...values.outbound.delays.slice(index + 1),
    ]);
  };

  handleDelaysDialogClose = () => {
    this.setState({
      isDelayCodesDialogOpen: false,
    });
  };

  handleDelaysDialogOpen = index => {
    this.setState({
      isDelayCodesDialogOpen: true,
      currentItemIndex: index,
    });
  };

  handleDelaysCodeSelect = code => {
    const { setFieldValue } = this.props;
    const { currentItemIndex } = this.state;

    if (code !== '00-05') {
      setFieldValue(`outbound.delays[${currentItemIndex}].code`, code);
    }
  };

  render() {
    const { values, onDeleteConfirmationDialogOpen, t } = this.props;
    const { isDelayCodesDialogOpen } = this.state;
    return (
      <>
        {values.outbound.delays.map((r, i) => (
          <FormBlock key={`ramp${i}`}>
            <Grid
              size={{ xs: 3 }}
              onClick={() => this.handleDelaysDialogOpen(i)}
            >
              <FormTextField
                fullWidth
                name={`outbound.delays[${i}].code`}
                label={t('Code')}
              />
            </Grid>
            <GridNumberField
              xs={3}
              name={`outbound.delays[${i}].duration`}
              label={t('Time_(min)')}
              allowedInputValue={positiveInteger}
            />
            <Placeholder xs={4} />
            <GridIconFab
              color="secondary"
              xs={2}
              icon="delete"
              onClick={() =>
                onDeleteConfirmationDialogOpen(
                  this.handleDeleteClick.bind(null, i)
                )
              }
            />
          </FormBlock>
        ))}
        <DelayCodesDialog
          isOpen={isDelayCodesDialogOpen}
          onClose={this.handleDelaysDialogClose}
          onSelect={this.handleDelaysCodeSelect}
        />
        <FormBlock>
          <Placeholder xs={9} />
          <GridButton
            variant="contained"
            color="primary"
            xs={3}
            label={t('ADD')}
            onClick={this.handleAddClick}
          />
          {values.outbound.delays.length > 0 && (
            <FormTextField
              name="outbound.delaysComments"
              label={t('Delay_comments')}
              multiline
              fullWidth
              variant="outlined"
              rows="4"
              maxRows="7"
            />
          )}
        </FormBlock>
      </>
    );
  }
}

export default withTranslation()(withDeletePopup(Delays));
